
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  layout: 'event',
  scrollToTop: false,
  async asyncData ({ $api, $config, store, route: { path, params: { slug }}, error }) {
    const {
      data: {
        items: event = [],
      } = {},
    } = await $api.events.getOneBySlug(slug, {
      domain: $config.preprEnvironmentDomain,
    })

    // Check publication if exists
    if (!event || !event.length) {
      error({
        context: `Couldn't create event.`,
        message: '(404) Activiteit niet gevonden',
        severity: 'info',
        statusCode: 404,
      })
      return false
    }

    // Set breadcrumbs
    store.dispatch('breadcrumbs/mirror', {
      path,
      mirror: `/activiteit/${slug}`,
    })

    return event[0]
  },
  data () {
    return {
      articles: [],
      hasMoreArticles: false,
      id: null,
    }
  },
  async fetch () {
    const {
      data: {
        items: articles = [],
        meta: { total = 0 } = {},
      } = {},
    } = await this.$api.articles.getAll({
      offset: this.articles.length,
      limit: 9,
      event: this.id,
    })

    this.articles.push(...articles)
    this.hasMoreArticles = total > this.articles.length
  },
}
